import { defineSlotRecipe } from '@chakra-ui/react';

export const fileUploadSlotRecipe = defineSlotRecipe({
  className: 'chakra-file-upload',
  slots: [
    'root',
    'dropzone',
    'item',
    'itemGroup',
    'itemName',
    'itemSizeText',
    'itemDeleteTrigger',
    'itemPreviewImage',
    'label',
    'trigger',
    'clearTrigger',
  ],
  base: {
    dropzone: {
      borderColor: 'border.secondary',
      borderRadius: 'md',
      color: 'text.tertiary',
      bg: 'surface.primary',
      transitionProperty: 'common',
      transitionDuration: 'normal',
      _hover: {
        borderColor: 'border.tertiary',
        bg: 'surface.secondary',
      },
      _focusVisible: {
        borderColor: 'border.action',
        boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
      },
      _disabled: {
        opacity: 0.6,
        cursor: 'not-allowed',
        borderColor: 'border.secondary',
        bg: 'surface.disabled',
      },
    },
    item: {
      bg: 'surface.secondary',
      borderRadius: 'md',
      border: '1px solid',
      borderColor: 'border.secondary',
      color: 'text.primary',
      p: 3,
    },
    itemName: {
      fontSize: 'sm',
      color: 'text.primary',
    },
    itemSizeText: {
      fontSize: 'xs',
      color: 'text.tertiary',
    },
    itemDeleteTrigger: {
      color: 'text.secondary',
      _hover: {
        color: 'text.danger',
      },
    },
    label: {
      color: 'text.primary',
      fontWeight: 'medium',
    },
    trigger: {
      color: 'text.action',
    },
    clearTrigger: {
      color: 'text.secondary',
      _hover: {
        color: 'text.danger',
      },
    },
  },
});
